/* eslint-disable react/prop-types */
import React, {forwardRef} from 'react';
import {injectIntl} from 'react-intl';

export default function withIntl(Component) {
  class Wrapper extends React.Component {
    render() {
      const {innerRef, ...props} = this.props;

      // eslint-disable-next-line react/jsx-props-no-spreading
      return <Component ref={innerRef} {...props} />;
    }
  }

  const IntlWrapper = injectIntl(Wrapper);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return forwardRef((props, ref) => <IntlWrapper {...props} innerRef={ref} />);
}

// source: https://github.com/formatjs/react-intl/issues/1211
